import { Chip } from "@mui/material";
import { FunctionComponent } from "react";
import SentimentVerySatisfiedRoundedIcon from '@mui/icons-material/SentimentVerySatisfiedRounded';
import SentimentDissatisfiedRoundedIcon from '@mui/icons-material/SentimentDissatisfiedRounded';

interface ChipBatizadoProps {
    status?: boolean
}

const ChipBatizado: FunctionComponent<ChipBatizadoProps> = ({ status }) => {
  return ( <>
      <Chip size="small" color={status ? 'primary' : 'error'} icon={status ? <SentimentVerySatisfiedRoundedIcon /> : <SentimentDissatisfiedRoundedIcon />} label={status ? 'Batizado' : 'Não'} />
  </> );
}

export default ChipBatizado;
